import { isLiveEligible, stateIndexAt, TERMINAL_RUN_STATES } from "@/lib/decisionGraph";

// Live-mode governance helpers. Live tailing renders ONLY what real ledger events
// back: the mode is chosen from the Run's actual status, every frame comes from a
// persisted event (numeric sequence), and the visible state can never run ahead
// of the events actually received.

export function decideMode(runStatus) {
  return isLiveEligible(runStatus) ? "live" : "replay";
}

// Ordered, de-duplicated insert. Anything without a real ledger sequence is
// refused — there is no such thing as a synthetic live frame.
export function mergeEvent(list, ev) {
  if (!ev || typeof ev.sequence !== "number") return list;
  if (list.some((e) => e.sequence === ev.sequence)) return list;
  const next = list.concat([ev]);
  next.sort((a, b) => a.sequence - b.sequence);
  return next;
}

// Live → completed transition fires on eof (the server only sends eof once the Run
// is terminal) or when a refreshed reconstruction reports a terminal status.
export function nextMode(mode, signal, runStatus) {
  if (mode === "live" && (signal === "eof" || TERMINAL_RUN_STATES.includes(runStatus))) return "completed";
  return mode;
}

export function terminalKind(runStatus) {
  return TERMINAL_RUN_STATES.includes(runStatus) ? runStatus : null;
}

// Agents on screen must map to the mobilization actually recorded.
export function backedAgentCount(events, workUnits) {
  const mob = (events || []).find((e) => e.event_type === "mas.agents_mobilized");
  const n = mob?.metadata?.agent_count;
  if (typeof n === "number") return n;
  return Array.isArray(workUnits) ? workUnits.length : 0;
}

// True when the rendered frame claims more than the real events support.
export function violatesLiveGovernance({ events, renderedState, renderedAgentCount, workUnits }) {
  const evs = events || [];
  const allowedState = evs.length ? stateIndexAt(evs, evs.length - 1) : 0;
  if (renderedState > allowedState) return true;
  if (typeof renderedAgentCount === "number" && renderedAgentCount > 0) {
    const allowedAgents = allowedState >= 2 ? backedAgentCount(evs, workUnits) : 0;
    if (renderedAgentCount > allowedAgents) return true;
  }
  return false;
}
